import { generateQueryParamsString, generateRequestUrl, OPEN_API } from './index';
import { makeOpenApiRequest } from './utils';
import { getCurrentLangId } from '../utils';
const endpoints = {
    getRallies: '/rallies',
};
export const getRallies = async (queryParams) => {
    const queryString = queryParams ? generateQueryParamsString(queryParams) : '';
    const url = generateRequestUrl(endpoints.getRallies + queryString);
    try {
        const { response, data } = await makeOpenApiRequest(url, 'GET', undefined, getCurrentLangId());
        const rallies = data?.['hydra:member'];
        if (response.ok && Array.isArray(rallies)) {
            return { ok: true, rallies };
        }
        const errorCode = data?.error?.code;
        return {
            ok: false,
            errorCode: errorCode === 'no_internet' || errorCode === 'server_error' ? errorCode : 'request_failed',
        };
    }
    catch (error) {
        // e.g. a response body that is not JSON; without this the list would stay in the loading state
        console.error('Failed to fetch rallies:', error);
        return { ok: false, errorCode: 'request_failed' };
    }
};
export const getRally = async (id) => {
    return await OPEN_API.GET.single({ endpoint: endpoints.getRallies, id });
};
